// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const ProductCodeApprvService = {};

ProductCodeApprvService.getProductCodeApprvList = function (userInput) {
  return lossClient({
    url: "/producttype/approvalItems?pageSize=1000&pageIndex=0",
    method: "get",
  });
};

export default ProductCodeApprvService;
